import React from 'react'

export function PiMoreIcon() {
  return (
    <svg width="5" height="20" viewBox="0 0 5 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.989258 2C0.989258 0.89543 1.88376 0 2.9872 0C4.09063 0 4.98513 0.89543 4.98513 2C4.98513 3.10457 4.09063 4 2.9872 4C1.88376 4 0.989258 3.10457 0.989258 2ZM0.989258 10C0.989258 8.89543 1.88376 8 2.9872 8C4.09063 8 4.98513 8.89543 4.98513 10C4.98513 11.1046 4.09063 12 2.9872 12C1.88376 12 0.989258 11.1046 0.989258 10ZM0.989258 18C0.989258 16.8954 1.88376 16 2.9872 16C4.09063 16 4.98513 16.8954 4.98513 18C4.98513 19.1046 4.09063 20 2.9872 20C1.88376 20 0.989258 19.1046 0.989258 18Z" fill="#134C85"/>
    </svg>

  )
}